export default __webpack_public_path__ + "static/logo-header-405716355dd175e4dd9209a35b544459.png";